module.exports = __webpack_public_path__ + "img/2.97410862.png";